import React, { useEffect, useState } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export default function NoteHistorique({ idLead, refreshKey }) {
  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(true);



  const champLabels = {
    note: "Note :",
    devis: "Devis :",
    mailDevis: "Devis envoyé :",
    dateValidation: "Devis validé :",
    etat: "Etat :"
  };


  const etatLabel = {
    0:"Nouvelle",
    1:"En cours",
    2:"Suivis",
    3:"Validés",
    4:"Réalisés",
    5:"Abandons"
  }

  useEffect(() => {
    if (!idLead) return;

    setLoading(true);
    axios
      .get(`${apiUrl}/IHM/api/lead.php?journalFiche=${idLead}`)
      .then((res) => {
        setLogData(res.data || []);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération de l'historique des notes :", err);
      })
      .finally(() => setLoading(false));
  }, [idLead, refreshKey]);

  

    const formatDateLocal = (datetimeStr) => {
    const d = new Date(datetimeStr);
    return `${d.toLocaleDateString()}`;
  };

   function isValidDate(value) {
    const date = new Date(value);
    return !isNaN(date.getTime()) && /^\d{4}-\d{2}-\d{2}/.test(value);
  }


  const allLogs = [...logData]
    .filter((entry) => entry.date_action)
    .sort((a, b) => new Date(b.date_action) - new Date(a.date_action));

  return (
    <>
      <div className="grid">
        <div className="col-12 md:col-12 font-bold">
          <div className="py-0 border-round-sm surface-100 flex flex-column">
            Historiques des notes :
          </div>
        </div>
      </div>

      <div className="grid">
        {loading ? (
          <div
            style={{ fontSize: "0.75rem", color: "#9ca3af", padding: "4px 0" }}
          >
            Chargement...
          </div>
        ) : allLogs.length === 0 ? (
          <div
            style={{ fontSize: "0.75rem", color: "#9ca3af", padding: "4px 0" }}
          >
            Aucune note enregistrée pour le moment.
          </div>
        ) : (
          <div className="col-12 md:col-12">
            {allLogs.map((entry, index) => (
              <div
                key={index}
                style={{
                  padding: "8px 10px",
                  fontSize: "0.75rem",
                  border: "1px solid #f3f4f6",
                  background: "#f9fafb",
                  borderRadius: "5px",
                  marginBottom: "6px",
                }}
              >
                <span>
                  [{formatDateLocal(entry.date_action)}]{" "}
                  {entry.action_type?.toUpperCase() === "INSERT"
                    ? "Insertion"
                    : champLabels[entry.champ_modifie] || entry.champ_modifie}
                </span>{" "}
                {entry.action_type?.toUpperCase() === "UPDATE" &&
                entry.nouvelle_valeur &&
                entry.nouvelle_valeur !== "0000-00-00" &&
                entry.nouvelle_valeur.toLowerCase() !== "null" ? (
                  <>
                    {entry.champ_modifie === "devis" && (
                      <span>{entry.message}</span>
                    )}
                    
                    {(entry.champ_modifie === "mailDevis" ||
                      entry.champ_modifie === "dateDevis" ||
                      entry.champ_modifie === "dateValidation") && (
                      <span>{formatDateLocal(entry.nouvelle_valeur)}</span>
                    )}
                    {entry.champ_modifie === "etat" && (
                      <span>{etatLabel[entry.nouvelle_valeur]}</span>
                    )}

                   {entry.champ_modifie === "note" && (
                      <span>{entry.nouvelle_valeur}</span>
                    )}

                    {/* <span>{entry.nouvelle_valeur}</span>*/} [{entry.utilisateur}]{" "} 
                  </>
                ) : entry.action_type?.toUpperCase() === "UPDATE" ? (
                  <>
                    <span style={{ color: "#999" }}>Non renseignée</span> - [
                    {entry.utilisateur}]{" "}
                    {entry.message && <>Note :{etatLabel[entry.note]} {entry.message}</>}
                  </>
                ) : null}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}